import React, { useState } from 'react';
import { ThumbsUp, PartyPopper, Heart, Lightbulb, Smile } from 'lucide-react';

const reactions = [
    { type: 'like', icon: ThumbsUp, color: '#3b82f6', label: 'Like' },
    { type: 'celebrate', icon: PartyPopper, color: '#eb4899', label: 'Celebrate' },
    { type: 'support', icon: Heart, color: '#f43f5e', label: 'Support' },
    { type: 'insightful', icon: Lightbulb, color: '#f59e0b', label: 'Insightful' },
    { type: 'funny', icon: Smile, color: '#0ea5e9', label: 'Funny' },
];

const ReactionSelector = ({ onSelect, onClose, isOpen }) => {
    const [hovered, setHovered] = useState(null);

    if (!isOpen) return null;

    return (
        <div
            className="glass-card animate-scale-up"
            style={{
                position: 'absolute',
                bottom: '100%',
                left: '0',
                display: 'flex',
                gap: '0.25rem',
                padding: '0.4rem',
                borderRadius: '30px',
                zIndex: 100,
                boxShadow: 'var(--shadow-apex)',
                background: 'rgba(15, 23, 42, 0.9)',
                backdropFilter: 'blur(20px)',
                border: '1px solid var(--glass-border)',
                paddingBottom: '12px',
                transform: 'translateY(2px)',
                overflow: 'visible'
            }}
            onMouseLeave={onClose}
            onClick={(e) => e.stopPropagation()}
        >
            {reactions.map((reac) => (
                <div key={reac.type} style={{ position: 'relative' }}>
                    {hovered === reac.type && (
                        <div style={{
                            position: 'absolute',
                            bottom: 'calc(100% + 12px)',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 101,
                            pointerEvents: 'none'
                        }}>
                            <div
                                style={{
                                    background: 'rgba(0, 0, 0, 0.95)',
                                    color: 'white',
                                    padding: '6px 14px',
                                    borderRadius: '20px',
                                    fontSize: '0.75rem',
                                    fontWeight: 700,
                                    whiteSpace: 'nowrap',
                                    boxShadow: '0 4px 15px rgba(0,0,0,0.4)',
                                    animation: 'scaleUp 0.15s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
                                }}
                            >
                                {reac.label}
                            </div>
                        </div>
                    )}
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onSelect(reac.type);
                        }}
                        onMouseEnter={() => setHovered(reac.type)}
                        onMouseLeave={() => setHovered(null)}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            padding: '0.6rem',
                            borderRadius: '50%',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                            color: reac.color,
                            transform: hovered === reac.type ? 'scale(1.2)' : 'scale(1)'
                        }}
                    >
                        <reac.icon size={22} fill={reac.type === 'support' ? reac.color : 'none'} />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default ReactionSelector;
